import { Grid, MaterialUICore } from '@iclinic/design-system';
import React from 'react';
import { useSelector } from 'react-redux';

import { HeaderTitle } from './styles';
import { getAutocomplete } from 'features/tissInvoicing/state/autocomplete/selectors';
import SelectField from 'features/tissInvoicing/components/appointmentGuide/SelectField';

const { MenuItem } = MaterialUICore;
const HeaderSection = () => {
  const { guide_versions } = useSelector(getAutocomplete);

  return (
    <Grid container item spacing={2} justifyContent="space-between">
      <Grid item xs={12} md={9}>
        <HeaderTitle data-testid="header_title">Guia de consulta</HeaderTitle>
      </Grid>
      <Grid item xs={12} md={3}>
        <SelectField label="Versão da guia" identifier="tiss_version">
          {guide_versions.map((version) => (
            <MenuItem key={version.version} value={version.version}>
              {version.version}
            </MenuItem>
          ))}
        </SelectField>
      </Grid>
    </Grid>
  );
};

export default HeaderSection;
